import type {
  CategoryEntityModel,
  CategoryInterface,
  NomenclatureGroupInterface,
  NomenclatureGroupModel,
} from '@/types'

export type TreeNode = CategoryInterface | NomenclatureGroupInterface

export type TreeNodeList = CategoryInterface[] | NomenclatureGroupInterface[]

export const isCategoryNode = (node: TreeNode): node is CategoryInterface =>
  'category' in node

export const getTreeNodeEntity = (
  node: TreeNode
): CategoryEntityModel | NomenclatureGroupModel =>
  isCategoryNode(node) ? node.category : node.nomenclatureGroup

export const getTreeNodeId = (node: TreeNode): string =>
  getTreeNodeEntity(node)?.id

export const getTreeNodeDescription = (node: TreeNode): string =>
  getTreeNodeEntity(node)?.description ?? ''

export function getTreeNodeChildren<T extends TreeNode>(node: T): T[]
export function getTreeNodeChildren(node: TreeNode): TreeNode[] {
  return (isCategoryNode(node) ? node.childCategories : node.childGroups) ?? []
}
